import { lazy, Suspense } from "react";
import { GlobalLoading } from "../Utils";

const Bookings = lazy(() => import("../Components/ProfilesType/CustomerCare/Bookings/Bookings"));
const CustomerCareHome = lazy(() => import("../Components/ProfilesType/CustomerCare/CustomerCareHome/CustomerCareHome"));
const PriorityDM = lazy(() => import("../Components/ProfilesType/CustomerCare/PriorityDM/PriorityDM"));
const ProfileApproval = lazy(() => import("../Components/ProfilesType/CustomerCare/ProfileApproval/ProfileApproval"));
const ProfileStatus = lazy(() => import("../Components/ProfilesType/CustomerCare/ProfileStatus/ProfileStatus"));
const ReferralRequest = lazy(() => import("../Components/ProfilesType/CustomerCare/ReferralRequest/ReferralRequest"));
const AmbassadorProgram = lazy(() => import("../Components/ProfilesType/CustomerCare/Program/AmbassadorProgram"));
const ShortlistedCandidates = lazy(() => import("../Components/ProfilesType/CustomerCare/Program/ShortlistedCandidates"));

export const customerCareRoutes = [
    {
        index: true,
        element: <Suspense fallback={<GlobalLoading />}><CustomerCareHome /></Suspense>,
    },
    {
        path: "profile-approval",
        element: <Suspense fallback={<GlobalLoading />}><ProfileApproval /></Suspense>,
    },
    {
        path: "profile-status",
        element: <Suspense fallback={<GlobalLoading />}><ProfileStatus /></Suspense>,
    },
    {
        path: "bookings",
        element: <Suspense fallback={<GlobalLoading />}><Bookings /></Suspense>,
    },
    {
        path: "priority-dm",
        element: <Suspense fallback={<GlobalLoading />}><PriorityDM /></Suspense>,
    },
    {
        path: "referral-request",
        element: <Suspense fallback={<GlobalLoading />}><ReferralRequest /></Suspense>,
    },
    {
        path: "ambassador-program",
        element: <Suspense fallback={<GlobalLoading />}><AmbassadorProgram /></Suspense>,
    },
    {
        path: "ambassador-program/shortlisted-candidates",
        element: <Suspense fallback={<GlobalLoading />}><ShortlistedCandidates /></Suspense>,
    },

]